/**
 * Brand apply / platform-wide stats 쿼리 키 팩토리
 *
 * userCount / brandCount 는 apply 페이지와 TrustBar(홈) 양쪽에서 공유한다.
 */

export const applyKeys = {
  all: ["applications"] as const,
  userCount: () => ["applications", "user-count"] as const,
  brandCount: () => ["applications", "brand-count"] as const,
};
